import gsap, { Power2, Power4 } from 'gsap';
import { Basics, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import BGVideo from '../layout/BGVideo';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import NoScroll from './NoScroll';
import Default from './Default';
import Header from '../layout/Header';
import InfiniteScroll__ArtistItem from '../scroll/InfiniteScroll__ArtistItem';

export default class Talents extends NoScroll {
   
  _calls = {
    hover: () => { 
      this.container.classList.add("--hover");
      this.scroller.pause();
      this.scroller2.pause();
    },
    out: () => {
      this.container.classList.remove("--hover");
      this.scroller.resume();
      this.scroller2.resume();
    }
  }

//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();

    this._left = GetBy.class("block-selected-works__ul")[0];
    this._right = GetBy.class("block-selected-works__ul")[1];
    this.billboard = GetBy.class("block-artist-billboard")[0];
    this.line1 = GetBy.class("name", this.billboard)[0];
    this.line2 = GetBy.class("name", this.billboard)[1];
    this.image = GetBy.selector("img", this.billboard)[0];
    this.footer = GetBy.class("artist-footer")[0];
    this.isMouseEnabled = false;

    Wrap.removePosition();

    if(!isSmartphone) {
      this.scroller = new InfiniteScroll(isTouch? InfiniteScroll.AXIS_Y : InfiniteScroll.AXIS_Y, {
          domResize: this.container,
          container: this._left,
          multiplicator: 1,
          minSpeed: .5,
          inverted: false,
          gap: 0,
          hasVirtuaScroll: true,
          itemClass: InfiniteScroll__ArtistItem,
      });
      this.scroller2 = new InfiniteScroll(isTouch? InfiniteScroll.AXIS_Y : InfiniteScroll.AXIS_Y, {
          domResize: this.container,
          container: this._right,
          multiplicator: 1,
          minSpeed: -.5,
          inverted: true,
          gap: 0,
          hasVirtuaScroll: false,
          itemClass: InfiniteScroll__ArtistItem,
      });

      this._left.addEventListener(Basics.mouseOver, this._calls.hover);
      this._left.addEventListener(Basics.mouseOut, this._calls.out);
      this._right.addEventListener(Basics.mouseOver, this._calls.hover);
      this._right.addEventListener(Basics.mouseOut, this._calls.out);

      this.scroller.checkHook = (e) => {
         this.scroller2.check(e);
      }
    }
  }

  beforeShow() {
    if(isSmartphone) {
       Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isTouch, multiplicator: 1 });
    };
    Header.showOverlay(true, true);
    Header.closeHeader();
    super.beforeShow();
  }

  show__effect(__call) {
    Wrap.directShow();
    if (this.isFirstTime) {
      Preloader.hide(() => { this.afterShow() });
    } else {
      this.afterShow();
    }
  }

  afterShow() {
    super.afterShow();
    gsap.to(this._left, {opacity:1, duration:.6, delay:0, ease:Power2.easeIn});
    gsap.to(this.line1, {opacity:1, duration:.7, delay:.1, ease:Power2.easeIn});
    gsap.to(this.image, {opacity:1, duration:.8, delay:.2, ease:Power2.easeIn});
    gsap.to(this.line2, {opacity:1, duration:.9, delay:.2, ease:Power2.easeIn});
    gsap.to(this.footer, {opacity:1, duration:1, delay:.2, ease:Power2.easeIn});
    gsap.to(this._right, {opacity:1, duration:1.1, delay:.2, ease:Power2.easeIn});

    if(!isSmartphone) {
      this.scroller.start();
      this.scroller.show();
      this.scroller2.start();
      this.scroller2.show();
    } else {
      Scroll.start();
      Scroll.show();
    }
  }

  hide__effect() {
    gsap.to(this._left, {opacity:0, duration:.3, delay:0, ease:Power2.easeIn});
    gsap.to(this._right, {opacity:0, duration:.3, delay:0, ease:Power2.easeIn});
    gsap.to(this.billboard, {opacity:0, duration:.4, delay:0, ease:Power2.easeOut});
    
    Scroll.hide();
    BGVideo.hide();
    Wrap.hide(() => { this.afterHide(); }, {delay:.3,duration:.1});
  }

  afterHide() {
    Header.hideOverlay();
    if(isSmartphone) Scroll.dispose();
    super.afterHide();
  }

  loop() {
      if(!isSmartphone) {
        this.scroller.loop();
        this.scroller2.loop();
      }
  }

  dispose() {
      Wrap.addPosition();
      this._left.removeEventListener(Basics.mouseOver, this._calls.hover);
      this._left.removeEventListener(Basics.mouseOut, this._calls.out);
      this._right.removeEventListener(Basics.mouseOver, this._calls.hover);
      this._right.removeEventListener(Basics.mouseOut, this._calls.out);
      if(!isSmartphone) {
        this.scroller.dispose();
        this.scroller2.dispose();
      }
  }

  resize() {
    if(!isSmartphone) {
      this.scroller.resize();
      this.scroller2.resize();
    }
  }
}

ControllerPage._addPage('page-artist', Talents)
